export default {
  browse:{
    table:{
      headers: [
        {
          text: 'No.',
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Question Set',
          value: 'QuestionSet',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Chapter',
          value: 'Chapter',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Question',
          value: 'Question',
          sortable: false,
          filterable: false,
        },
      ],
    },
  },
  read:{
    tabs:[
      {
        key:'Info',
        label:'info',
      },
    ],
    table:{
      headers: [
        {
          text: 'Question Set',
          value: 'QuestionSet',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Chapter',
          value: 'Chapter',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Question',
          value: 'Question',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Created',
          value: 'timestampCreated',
          filterable: false,
        },
        {
          text: 'Last Updated',
          value: 'timestampUpdated',
          filterable: false,
        },
      ],
    },
  },
  add:false,
  edit:false,
  delete:false,
}